import { render, staticRenderFns } from "./svgRadiusComponent.vue?vue&type=template&id=2ea31180"
import script from "./svgRadiusComponent.vue?vue&type=script&lang=js"
export * from "./svgRadiusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports